import { useWhatsNewLatestGetV2 } from "@btnet/services-btnet/handlers/whats-new/whats-new";

import { BTBadge } from "commonComponents/btWrappers/BTBadge/BTBadge";

import { hasUnseenWhatsNew } from "entity/whatsNew/whatsNew.storage";

interface IWhatsNewNavBadgeProps {
    children: React.ReactNode;
    /** Account the viewer is in. Scopes the device-local watermark. */
    builderId: number;
    /** Viewer's global user id, so a shared computer does not leak one person's cleared dot. */
    userId: number | null;
    /** Poll cadence, from the whatsNewPollInterval App Default. */
    refetchIntervalSeconds: number;
}

/**
 * The dot on the What's New nav icon. A dot rather than a count because reads are not tracked per
 * person - it only answers "is there anything new since this person last looked here?".
 */
export function WhatsNewNavBadge({
    children,
    builderId,
    userId,
    refetchIntervalSeconds,
}: Readonly<IWhatsNewNavBadgeProps>) {
    // Nothing is pushed to the browser, so poll like the notifications badge. Focus refetches are
    // off because each tab switch would add a request.
    const { data } = useWhatsNewLatestGetV2({
        query: { refetchInterval: 1000 * refetchIntervalSeconds, refetchOnWindowFocus: false },
    });

    const showDot = hasUnseenWhatsNew(builderId, userId, data?.data.latestPublishedDateUtc);

    return (
        <BTBadge dot={showDot} offset={[-5, 0]}>
            {children}
        </BTBadge>
    );
}
